import { render, staticRenderFns } from "./FxForm.vue?vue&type=template&id=3801f86f&"
import script from "./FxForm.vue?vue&type=script&lang=js&"
export * from "./FxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports